export default __webpack_public_path__ + "static/part-time-advantage-3-950706e1c938791cf16d39e9d556f11a.png";